module.exports = __webpack_public_path__ + "static/media/extraVolunteer.01131059.png";